(function(window) {
  'use strict';

  /*
   * The checked-in theme.min.js currently calls:
   *   $('.js-product-slider').click('setPosition')
   * instead of Slick's setPosition method. Keep the workaround narrowly
   * scoped to the product slider until the minified bundle can be rebuilt.
  */
  var $ = window.jQuery;
  if ($ && $.fn && $.fn.click && !$.fn.productSetPositionCompat) {
    var originalClick = $.fn.click;
    var lastProductSetPosition = 0;

    $.fn.click = function() {
      if (arguments.length === 1 && arguments[0] === 'setPosition' && this.filter('.js-product-slider').length) {
        var now = Date.now();
        if (now - lastProductSetPosition < 1000) return this;
        lastProductSetPosition = now;

        this.filter('.js-product-slider').each(function() {
          var slider = $(this);
          if (slider.hasClass('slick-initialized') && typeof slider.slick === 'function') {
            var refresh = function() { slider.slick('setPosition'); };
            if (typeof window.requestAnimationFrame === 'function') {
              window.requestAnimationFrame(refresh);
            } else {
              window.setTimeout(refresh, 0);
            }
          }
        });
        return this;
      }

      return originalClick.apply(this, arguments);
    };

    $.fn.productSetPositionCompat = true;
  }

  /*
   * PayPal's app block inserts #paypal-upstream-messaging-product immediately
   * before the product form. Move that element into the server-rendered slot
   * so its height is reserved before the asynchronous app response arrives.
   */
  function setupPayPalMessageSlot() {
    if (!document.body || !document.querySelector('[data-paypal-message-reserve]')) {
      return;
    }

    var slot = document.querySelector('[data-paypal-message-reserve]');
    var moveMessage = function() {
      var message = document.getElementById('paypal-upstream-messaging-product');
      if (message && message.parentNode !== slot) {
        slot.appendChild(message);
      }
    };

    moveMessage();

    if (window.MutationObserver) {
      var observer = new MutationObserver(moveMessage);
      observer.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function() { observer.disconnect(); }, 30000);
    } else {
      window.setTimeout(moveMessage, 1000);
      window.setTimeout(moveMessage, 3000);
    }
  }

  setupPayPalMessageSlot();
})(window);
